document.addEventListener('DOMContentLoaded', function(){
  const jobForm = document.getElementById('job-vacants');
  const submitBtn = jobForm.querySelector('.js-register-submit');

  jobForm.addEventListener('submit', function(event) {
    event.preventDefault();
    submitBtn.classList.add('js-loading');
    const formData = new FormData(event.target);
    fetch('https://four-phones-eu-jqnwf.ondigitalocean.app/api/saveJobApplication', {
      method: "POST",
      credentials: "same-origin",
      body: formData,
      headers: {
        "ContentType": "multipart/form-data"
      }
    })
    .then((response) => {
      if (response.ok) return response.json();

      return response.text().then(response => { throw new Error(response) })
    })
    .then((data) => {
      submitBtn.classList.remove('js-loading');

      const successMessage = jobForm.querySelector('.job-form__message--success')
      successMessage.style.display = 'block';
      successMessage.scrollIntoView({ behavior: 'instant', block: 'center' });
      setTimeout(() => successMessage.style.display = 'none', 3000)
    }).catch((error) => {
      console.log(error)
      submitBtn.classList.remove('js-loading');

      const errorMessage = jobForm.querySelector('.job-form__message--error')
      const errorText = errorMessage.querySelector('span')
      errorMessage.style.display = 'block';
      errorText.innerHTML = error.message;
      errorMessage.scrollIntoView({ behavior: 'instant', block: 'center' });

      setTimeout(() => errorMessage.style.display = 'none', 3000)
    });
  });
});